module.exports = __webpack_public_path__ + "static/media/base64.e0cea63e.mjs";


//////////////////
// WEBPACK FOOTER
// /node_modules/@imgix/js-core/node_modules/js-base64/base64.mjs
// module id = 349
// module chunks = 1